import React from 'react';
import { useTranslation } from 'react-i18next';

const LoginInvalidStatus = () => {
    const { t } = useTranslation();

	return <div style={{ display: 'flex', justifyContent: 'center', height: '100vh', marginTop: '20vh' }}>
        <p>{t('LOGIN_FAILED_MESSAGE')}</p>
    </div>;
};
export default LoginInvalidStatus;